<template>
  <v-container fluid>
    <FilterDtp />

    <v-row justify="space-between">
      <v-col cols="12" sm="12" md="7" lg="8" xl="9">
        <Osmap />
      </v-col>
      <v-col cols="12" sm="12" md="5" lg="4" xl="3">
        <Info />
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <Table />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Osmap from "../components/osmap.vue";
import Info from "../components/Info.vue";
import Table from "../components/Table.vue";
import FilterDtp from "../components/FilterDtp.vue";

export default {
  components: {
    Osmap,
    Info,
    Table,
    FilterDtp
  },
  data() {
    return {
      menu: false,
    };
  },
  methods: {},
  computed: {},
};
</script>

<style>
</style>
